// Parse Odoo version string into a display-friendly format
// Handles formats like "18.0", "19.0", "saas~18.2", "saas~19.1+e"
// Returns { version: "19.1", isSaas: true, raw: "saas~19.1+e" }
export const parseOdooVersion = (versionString) => {
  if (!versionString) return null

  // Check for SaaS version format (e.g., "saas~19.1+e", "saas~18.2")
  const saasMatch = versionString.match(/saas~(\d+\.\d+)/)
  if (saasMatch) {
    return {
      version: saasMatch[1],
      isSaas: true,
      raw: versionString
    }
  }

  // Check for standard version format (e.g., "18.0", "19.0")
  const standardMatch = versionString.match(/^(\d+\.\d+)/)
  if (standardMatch) {
    return {
      version: standardMatch[1],
      isSaas: false,
      raw: versionString
    }
  }

  // Fallback - just return the raw string
  return {
    version: versionString,
    isSaas: false,
    raw: versionString
  }
}

// Format Odoo version for display
// "saas~19.1+e" -> "19.1 (SaaS)"
// "18.0" -> "18.0"
export const formatOdooVersion = (versionString) => {
  const parsed = parseOdooVersion(versionString)
  if (!parsed) return null
  return parsed.isSaas ? `${parsed.version} (SaaS)` : parsed.version
}

// Derive destination system from detected Odoo version
// Handles formats like "18.0", "19.0", "saas~18.2", "saas~19.1+e"
export const deriveDestinationSystem = (version) => {
  const parsed = parseOdooVersion(version)
  if (!parsed) return 'ODOO_18'

  const majorVersion = parsed.version.split('.')[0]
  if (majorVersion === '19') return 'ODOO_19'
  if (majorVersion === '18') return 'ODOO_18'

  // For older versions or unknown, default to 18
  return 'ODOO_18'
}

// Generate default migration name with today's date
export const getDefaultMigrationName = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `Migration ${year}-${month}-${day}`
}

// Clean Odoo URL - extract just the origin (protocol + host)
// "https://company.odoo.com/odoo/something" -> "https://company.odoo.com"
export const cleanOdooUrl = (url) => {
  if (!url) return url

  try {
    const parsed = new URL(url.trim())
    return parsed.origin
  } catch {
    // If URL parsing fails, return trimmed original
    return url.trim()
  }
}
